document.addEventListener("DOMContentLoaded", function () {
    const videoPlayerFeeds = document.querySelectorAll(".video-player-feed .swiper");
    const videoPlayerFeedNext = document.querySelectorAll(".video-player-swiper-next");
    const videoPlayerFeedPrev = document.querySelectorAll(".video-player-swiper-prev");
    let swiperInstances = [];

    // Function to initialize Swiper instances
    function initializeSwiper() {
        for (let i = 0; i < videoPlayerFeeds.length; i++) {
            if (!swiperInstances[i]) {
                // Only initialize if not already initialized
                videoPlayerFeeds[i].classList.add("swiper-" + i);
                videoPlayerFeedNext[i]?.classList.add("video-player-swiper-next-" + i);
                videoPlayerFeedPrev[i]?.classList.add("video-player-swiper-prev-" + i);

                swiperInstances[i] = new Swiper(".video-player-feed .swiper-" + i, {
                    simulateTouch: true,
                    grabCursor: false,
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                    centeredSlides: false,
                    navigation: {
                        nextEl: ".video-player-swiper-next-" + i,
                        prevEl: ".video-player-swiper-prev-" + i,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 2,
                        },
                        576: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3.5,
                        },
                        992: {
                            direction: "vertical",
                            slidesPerView: "auto",
                        },
                    },
                });
            }
        }
    }

    // Function to destroy Swiper instances
    function destroySwiper() {
        swiperInstances.forEach((instance, index) => {
            if (instance) {
                instance.destroy(true, true); // Destroy Swiper instance and cleanup DOM modifications
                swiperInstances[index] = null;
            }
        });
    }

    // Function to handle window resize and initialize or destroy Swiper based on screen width
    function handleResize() {
        if (window.innerWidth < 992) {
            initializeSwiper();
        } else {
            destroySwiper();
        }
    }

    // Initial call and listener for window resize
    handleResize();
    window.addEventListener("resize", handleResize);
});

document.addEventListener("DOMContentLoaded", () => {
    const videoPlayer = document.querySelector(".video-player");

    if (videoPlayer) {
        const leftSection = videoPlayer.querySelector(".left .video-player__video");
        const rightSection = videoPlayer.querySelector(".right .video-player__feed");

        const setHeight = () => {
            if (window.innerWidth >= 992) {
                const leftHeight = leftSection.offsetHeight;
                rightSection.style.height = `${leftHeight}px`;
            } else {
                // Reset height for screen widths less than 992px
                rightSection.style.height = "";
            }
        };

        // Set initial height and update on resize
        setHeight();
        window.addEventListener("resize", setHeight);
    }
});
